import {takeEvery} from 'redux-saga/effects'

import {
  CREATE_ACADEMIC_RECORD,
  DELETE_ACADEMIC_RECORD,
  GET_ACADEMIC_RECORDS,
  GET_ACADEMIC_RECORD_OPTIONS,
  UPDATE_ACADEMIC_RECORD,
} from '../../../Actions/AcademicRecord/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* academicRecordSaga() {
  yield takeEvery(GET_ACADEMIC_RECORDS, fetchData)
  yield takeEvery(GET_ACADEMIC_RECORD_OPTIONS, fetchData)
  yield takeEvery(CREATE_ACADEMIC_RECORD, fetchData)
  yield takeEvery(UPDATE_ACADEMIC_RECORD, fetchData)
  yield takeEvery(DELETE_ACADEMIC_RECORD, fetchData)
}

export default academicRecordSaga
